import gql from 'graphql-tag';
import {
    projectFile,
    workItemCategory,
    message,
    userWithoutContact,
    s3Object
} from './fragments';

export const createProject = gql`
    mutation CreateProject($input: CreateProjectInput!) {
        createProject(input: $input) {
            id
            name
            owner {
                id
                givenName
                familyName
                username
            }
            ownerStr
            primaryType
            secondaryType
            stage
            estimatedStart
            location {
                locality
                region
                country
            }
            workItems {
                categories {
                    ...WorkItemCategoryFragment
                }
                scope
            }
            categoryStr
            files {
                ...ProjectFileFragment
            }
            views
            status
        }
    }
    ${projectFile}
    ${workItemCategory}
`;

export const createBid = gql`
    mutation CreateBid($input: CreateBidInput!) {
        createBid(input: $input) {
            id
            project {
                id
            }
            conversation {
                id
            }
            userBidder {
                id
            }
            events {
                timestamp
                status
            }
        }
    }
`;

export const createConvo = gql`
    mutation CreateConvo($input: CreateConversationInput!) {
        createConvo(input: $input) {
            id
            name
            createdAt
            associated {
                items {
                    convoLinkUserId
                    user {
                        id
                        givenName
                        familyName
                    }
                }
            }
        }
    }
`;

export const createMessage = gql`
    mutation CreateMessage($input: CreateMessageInput!) {
        createMessage(input: $input) {
            ...MessageFragment
        }
    }
    ${message}
`;

export const registerUserWithEmail = gql`
    mutation RegisterUser($input: CreateUserInput!) {
        registerUser(input: $input) {
            ...UserWithoutContact
            email
        }
    }
    ${userWithoutContact}
`;

export const registerUserWithPhoneNumber = gql`
    mutation RegisterUser($input: CreateUserInput) {
        registerUser(input: $input) {
            ...UserWithoutContact
        }
    }
    ${userWithoutContact}
`;

export const updateUser = gql`
    mutation updateUser(
        $id: ID!
        $email: String
        $preferredUsername: String
        $role: String
        $biography: String
        $location: String
        $facebook: String
        $twitter: String
        $linkedIn: String
        $personalSite: String
        $gravatar: String
        $avatar: S3ObjectInput
        $isGravatar: Boolean
        $userCompanyID: ID
    ) {
        updateUser(
            input: {
                id: $id
                email: $email
                preferredUsername: $preferredUsername
                role: $role
                biography: $biography
                location: $location
                facebook: $facebook
                twitter: $twitter
                linkedIn: $linkedIn
                personalSite: $personalSite
                gravatar: $gravatar
                isGravatar: $isGravatar
                avatar: $avatar
                userCompanyID: $userCompanyID
            }
        ) {
            id
            email
            preferredUsername
            role
            biography
            location
            facebook
            twitter
            linkedIn
            personalSite
            gravatar
            isGravatar
            avatar {
                ...S3ObjectFragment
            }
            userCompanyID
        }
    }
    ${s3Object}
`;

export const createConvoLink = gql`
    mutation createConvoLink($userId: ID!, $convoId: ID!, $name: String!) {
        createConvoLink(
            input: {
                convoLinkUserId: $userId
                convoLinkConversationId: $convoId
                name: $name
                status: "CREATING"
            }
        ) {
            id
            name
            status
            conversation {
                id
                name
                createdAt
                associated {
                    items {
                        convoLinkUserId
                        user {
                            id
                            givenName
                            familyName
                        }
                    }
                }
            }
        }
    }
`;

export const updateProject = gql`
    mutation updateProject($input: UpdateProjectInput!) {
        updateProject(input: $input) {
            estimatedStart
            files {
                ...ProjectFileFragment
            }
            id
            name
            primaryType
            secondaryType
            stage
            workItems {
                categories {
                    ...WorkItemCategoryFragment
                }
                scope
            }
        }
    }
    ${workItemCategory}
    ${projectFile}
`;

export const deleteProject = gql`
    mutation deleteProject($input: DeleteProjectInput!) {
        deleteProject(input: $input) {
            id
        }
    }
`;

export const updateConvoLink = gql`
    mutation updateConvoLink($id: ID!) {
        updateConvoLink(input: { id: $id, status: "READY" }) {
            id
            name
            convoLinkUserId
            status
            conversation {
                id
                name
                createdAt
                associated {
                    items {
                        convoLinkUserId
                        user {
                            id
                            givenName
                            familyName
                        }
                    }
                }
            }
        }
    }
`;

export const registerCompany = gql`
    mutation registerCompany($input: CreateCompanyInput!) {
        registerCompany(input: $input) {
            id
            name
            email
            website
            size
            location
            description
            avatar {
                key
            }
            facebook
            twitter
            owner {
                id
            }
            phoneNumber
            linkedIn
            facebook
            yearFounded
            about
            specialties
        }
    }
`;

export const updateCompany = gql`
    mutation updateCompany($input: UpdateCompanyInput!) {
        updateCompany(input: $input) {
            id
            name
            email
            website
            size
            location
            description
            avatar {
                ...S3ObjectFragment
            }
            facebook
            twitter
            owner {
                id
            }
            phoneNumber
            linkedIn
            facebook
            yearFounded
            about
            specialties
            businessType
            licenseNumber
            licenseState
            verifications {
                ...S3ObjectFragment
            }
        }
    }
    ${s3Object}
`;
